import { CommonModule } from "@angular/common";
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

export interface PillToggleOption<T> {
  label: string;
  value: T;
}

@Component({
  selector: "pill-toggle",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./pill-toggle.component.html",
  styleUrls: ["./pill-toggle.component.scss"],
})
export class PillToggleComponent<T = unknown> {
  @Input() options: PillToggleOption<T>[] = [];
  @Input() initialValue: T | null = null;
  @Input() activeValue: T | null = null;

  @Output() onToggleChanged = new EventEmitter<T>();

  @ContentChild(TemplateRef) optionTemplate?: TemplateRef<{ $implicit: PillToggleOption<T> }>;

  ngOnInit() {
    this.activeValue = this.activeValue
      ?? this.initialValue
      ?? this.options?.[0]?.value
      ?? null;

    if (this.activeValue === null) {
      throw new Error("PillToggleComponent requires at least one option or an initialValue.");
    }
  }

  select(value: T): void {
    this.activeValue = value;
    this.onToggleChanged.emit(value);
  }
}